// extracted by mini-css-extract-plugin
export var addToCartButton = "_qj-b";
export var arrowButtonContainer = "_qj-9";
export var arrowButtonIcon = "_qj-a";
export var carouselArrowButton = "_qj-6";
export var carouselElementContainer = "_qj-1";
export var left = "_qj-7";
export var productDisplayCarouselContainer = "_qj-0";
export var productTileContainer = "_qj-2";
export var productTileImage = "_qj-4";
export var productTileImageContainer = "_qj-3";
export var productTileTitle = "_qj-5";
export var right = "_qj-8";
export var sliderOverflow = "_qj-c";